import React from "react";
import { Row } from "react-bootstrap";
import { Switch, Route } from "react-router-dom";
import { SettingsSidebar } from "./components"
import { SettingsPage } from "./SettingsPage";
import { AdminPage } from "./AdminPage";
import { TemplatesPage } from "./TemplatesPage";
import { FeedsPage } from "./FeedsPage";
import { AffiliatePage } from "./AffiliatePage";
import { BillingPage } from "./BillingPage";
import { SupportPage } from "./SupportPage";
import { FeedPage } from "./FeedPage";
import { FeedsAdminPage } from "./FeedsAdminPage";
import { FeedAdminPage } from "./FeedAdminPage";
import { TemplatePage } from "./TemplatePage";
import { NavigationHelper } from "../helpers";
import { CommissionCheckPage } from "./CommissionCheckPage";
import { AccountWarnings } from "../components/AccountWarnings";

interface Props {
  location: any;
}

export const SettingsRouter: React.FC<Props> = (props) => {

  React.useEffect(NavigationHelper.hideMobileSidebar, [window.location.href]) // eslint-disable-line


  return (
    <>
      <a href="about:blank" onClick={e => { e.preventDefault(); NavigationHelper.toggleMobileSidebar() }} className="d-md-none" id="sidebarToggle"><i className="fas fa-bars"></i></a>
      <Row>
        <nav className="col-sm-3 col-md-2 d-none d-md-block bg-dark sidebar" id="sidebar">
          <SettingsSidebar />
        </nav>
        <main role="main" className="col-sm-12 ml-sm-auto col-md-10 pt-3">
          <AccountWarnings />
          <Switch>
            <Route path="/settings/affiliate/check/:id" render={(props) => <CommissionCheckPage routeData={props} />}></Route>
            <Route path="/settings/affiliate"><AffiliatePage /></Route>
            <Route path="/settings/admin"><AdminPage /></Route>
            <Route path="/settings/billing"><BillingPage /></Route>
            <Route path="/settings/feeds/:id" render={(props) => <FeedPage routeData={props} />}></Route>
            <Route path="/settings/feeds"><FeedsPage /></Route>
            <Route path="/settings/support"><SupportPage /></Route>
            <Route path="/settings/templates/:id" render={(props) => <TemplatePage routeData={props} />}></Route>
            <Route path="/settings/templates"><TemplatesPage /></Route>
            <Route path="/settings/feedAdmin/:id" render={(props) => <FeedAdminPage routeData={props} />}></Route>
            <Route path="/settings/feedAdmin"><FeedsAdminPage /></Route>
            <Route path="/settings"><SettingsPage /></Route>

          </Switch>
        </main>
      </Row>
    </>
  );
};